import 'rxjs/add/operator/map';
import 'rxjs/add/operator/take';

import { Store } from '@ngrx/store';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import * as Auth from '../actions/auth.actions';
import * as fromAuth from '../reducers';

@Injectable()
export class AnonymousGuard implements CanActivate {

  // Constructor
  constructor(private store: Store<fromAuth.State>) {}

  // Can Activate
  canActivate(router: ActivatedRouteSnapshot, routerState: RouterStateSnapshot): Observable<boolean> {
    return this.store.select(state => state.auth.login)
      .map((authed: any) => {
        if (authed.resetPassword && !(routerState.url === '/force-password')) {
          this.store.dispatch(new Auth.ForcePasswordRedirect());
        }
        else if (authed.token && !authed.resetPassword) {
          if (authed.staff && !authed.resetPassword) this.store.dispatch(new Auth.DashboardStaffRedirect());
          else if (!authed.staff && !authed.resetPassword) this.store.dispatch(new Auth.DashboardRedirect());
          return false;
        }

        return true;
      })
      .take(1);
  }

}



// WEBPACK FOOTER //
// ./src/app/auth/services/anonymous-guard.service.ts